export const TAGS_STYLES = {
  control: (base, state) => ({
    ...base,
    backgroundColor: state.isFocused ? 'white' : '#f0f0f0',
    border: state.isFocused ? 'none' : '1px solid rgba(0, 0, 0, 0.2)',
    boxShadow: state.isFocused
      ? 'inset 0 0px 2px rgba(10, 10, 10, 0.5)'
      : 'inset 0 1px 2px rgba(10, 10, 10, 0.1)',
    color: '#828282',
    fontSize: '14px',
    lineHeight: '1.2',
    minHeight: '40px',
    borderRadius: '3px',
  }),
  multiValue: (base, state) => {
    const labelWidth = state.children && state.children.length > 50 ? '100px' : 'auto'
    return {
      ...base,
      width: labelWidth,
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      padding: '4px 10px',
      background: '#B59B70',
      borderRadius: '4px',
      fontWeight: '500',
      fontSize: '14px',
      lineHeight: '15px',
      color: '#FFFFFF',
      height: '23px',
      alignItems: 'center',
    }
  },
  multiValueRemove: (base) => ({
    ...base,
    color: 'white',
    cursor: 'pointer',
    ':hover': {
      backgroundColor: 'transparent',
    },
    svg: {
      visability: 'visible',
    },
  }),
  multiValueLabel: (base) => {
    return {
      ...base,
      color: 'white',
    }
  },
  placeholder: (base, state) => ({
    ...base,
    color: state.isFocused ? 'black' : 'none',
    textAlign: 'center',
    position: 'absolute',
    left: '50%',
    transform: 'translateX(-50%)',
    top: '21.5%',
    fontWeight: '500',
  }),
  menu: (base) => ({
    ...base,
    overflow: 'hidden',
    borderRadius: '9px',
  }),
  menuList: (base) => ({
    ...base,
    padding: 0,
  }),
  option: (provided, state) => ({
    ...provided,
    background: state.isSelected ? '#B59B70' : provided.color,
    color: state.isSelected ? '#FFFFFF' : '#4A4A4A',
    fontWeight: '500',
    fontSize: '14px',
    padding: '10px 18px',
  }),
  input: (base) => {
    return {
      ...base,
      padding: 0,
      flex: 1,
    }
  },
}
